<div class="snackbar {{show}}">{{message}}</div>
<section class="container">
    <section class="side">
        <div class="avatar">
            <i class="fas fa-user-circle fa-8x profile"></i>
            <h2>Hello {{name}}!</h2>
        </div>
        <div class="menu">
            <button (click)='showWindow(1)' class="{{activated1}}">Account Details</button>
            <button (click)='showWindow(2)' class="{{activated2}}">Current Orders</button>
            <button (click)='showWindow(3)' class="{{activated3}}">Past Orders</button>
            <button (click)='showWindow(4)' class="{{activated4}}">Change Password</button>
        </div>
    </section>
    <section class="main-window">
        <div class="details {{showDetails}}">
            <div class="block">
                <p>Name:</p>
                <input class="signup-text {{editPro}}" name="fname" type="text" placeholder=""
                    [(ngModel)]="params.first_name">
                <input class="signup-text {{displayPro}}" name="fname" type="text" placeholder=""
                    [(ngModel)]="params.first_name" disabled>
                <input class="signup-text {{editPro}}" name="fname" type="text" placeholder=""
                    [(ngModel)]="params.last_name">
                <input class="signup-text {{displayPro}}" name="fname" type="text" placeholder=""
                    [(ngModel)]="params.last_name" disabled>
            </div>
            <div class="block">
                <p>Email:</p>
                <input class="signup-text {{editPro}}" name="email" type="email" placeholder=""
                    [(ngModel)]="params.email">
                <input class="signup-text {{displayPro}}" name="email" type="email" placeholder=""
                    [(ngModel)]="params.email" disabled>
            </div>
            <div class="block">
                <p>Phone:</p>
                <input class="signup-text {{editPro}}" name="email" type="email" placeholder=""
                    [(ngModel)]="params.phone">
                <input class="signup-text {{displayPro}}" name="email" type="email" placeholder=""
                    [(ngModel)]="params.phone" disabled>
            </div>
            <div class="block">
                <p>Gender:</p>
                <select class="signup-select {{editPro}}" name="gender" [(ngModel)]="params.gender">
                    <option value=1>Male</option>
                    <option value=2>Female</option>
                </select>
                <select class="signup-select {{displayPro}}" name="gender" [(ngModel)]="params.gender" disabled>
                    <option value=1>Male</option>
                    <option value=2>Female</option>
                </select>
            </div>
            <div class="block">
                <p>Country:</p>
                <select class="signup-select {{editPro}}" name="country" [(ngModel)]="params.country">
                    <option value="1">Pakistan</option>
                </select>
                <select class="signup-select {{displayPro}}" name="country" [(ngModel)]="params.country" disabled>
                    <option value="1">Pakistan</option>
                </select>
            </div>
            <div class="block">
                <p>City:</p>
                <select class="signup-select {{editPro}}" name="city" [(ngModel)]="params.city">
                    <option value="1">Karachi</option>
                </select>
                <select class="signup-select {{displayPro}}" name="city" [(ngModel)]="params.city" disabled>
                    <option value="1">Karachi</option>
                </select>
            </div>
            <div class="block">
                <p>Address:</p>
                <textarea class="signup-text-area {{editPro}}" name="message" rows="10" cols="30"
                    placeholder="Enter Complete Street Address " [(ngModel)]="params.address"></textarea>
                <textarea class="signup-text-area {{displayPro}}" name="message" rows="10" cols="30"
                    placeholder="Enter Complete Street Address " [(ngModel)]="params.address" disabled></textarea>
            </div>

            <div class="block">
                <button class="sign {{editPro}}" type="submit" (click)="editProfile()">Save Changes</button>
                <button class="sign {{displayPro}}" type="submit" (click)="edit()">Edit Profile</button>
            </div>
        </div>
        <div class="current-orders {{showCurrentOrders}}">
            <div class="loader" *ngIf="isLoading">
                <mat-spinner style="margin:0 auto;" *ngIf="isLoading"></mat-spinner>
            </div>
            <div *ngIf="!isLoading">
                <div class="c-orders" *ngFor="let order of orders;index as i">
                    <div *ngIf="order.order_status!=5 && order.order_status!=6">
                        <div class="double">
                            <h2>Order ID: <span>{{order._id}}</span></h2>
                        </div>
                        <div class="double">
                            <p><b>Dress Name:</b> {{order.cloth_id.dress_name}}</p>
                            <p><b>Vendor's Shop:</b> {{order.vendor_id.shop_name}}</p>
                        </div>
                        <div class="double">
                            <p><b>start date:</b> {{order.start_date | date: 'shortDate'}}</p>
                            <p *ngIf="order.order_status==1"><b>Order status:</b> Initial</p>
                            <p *ngIf="order.order_status==2"><b>Order status:</b> Posted</p>
                            <p *ngIf="order.order_status==3"><b>Order status:</b> Accepted</p>
                            <p *ngIf="order.order_status==4"><b>Order status:</b> Ongoing</p>
                            <p *ngIf="order.order_status==5"><b>Order status:</b> Completed</p>
                            <p *ngIf="order.order_status==6"><b>Order status:</b> Cancelled</p>
                        </div>
                        <div class="double">
                            <p><b>end date:</b> {{order.end_date | date: 'shortDate'}}</p>
                            <p><b>Rent: {{order.rent}}</b></p>
                        </div>
                        <div class="double">
                            <button *ngIf="order.order_status==5" (click)="openDialog(order)">Review</button>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
        <div class="past-orders {{showPastOrders}}">
            <div class="loader" *ngIf="isLoading">
                <mat-spinner style="margin:0 auto;" *ngIf="isLoading"></mat-spinner>
            </div>
            <div *ngIf="!isLoading">
                <div class="c-orders" *ngFor="let order of orders;index as i">
                    <div *ngIf="order.order_status==5 || order.order_status==6">
                        <div class="double">
                            <h2>Order ID: <span>{{order._id}}</span></h2>
                        </div>
                        <div class="double">
                            <p><b>Dress Name:</b> {{order.cloth_id.dress_name}}</p>
                            <p><b>Vendor's Shop:</b> {{order.vendor_id.shop_name}}</p>
                        </div>
                        <div class="double">
                            <p><b>start date:</b> {{order.start_date | date: 'shortDate'}}</p>
                            <p *ngIf="order.order_status==1"><b>Order status:</b> Initial</p>
                            <p *ngIf="order.order_status==2"><b>Order status:</b> Posted</p>
                            <p *ngIf="order.order_status==3"><b>Order status:</b> Accepted</p>
                            <p *ngIf="order.order_status==4"><b>Order status:</b> Ongoing</p>
                            <p *ngIf="order.order_status==5"><b>Order status:</b> Completed</p>
                            <p *ngIf="order.order_status==6"><b>Order status:</b> Cancelled</p>
                        </div>
                        <div class="double">
                            <p><b>end date:</b> {{order.end_date | date: 'shortDate'}}</p>
                            <p><b>Rent: {{order.rent}}</b></p>
                        </div>
                        <div class="double" style="justify-content: center;">
                            <button *ngIf="order.order_status==5 && order.is_reviewed==false" (click)="openDialog(order)">Review</button>
                        </div>
                        <hr>
                    </div>
                </div>
            </div>
        </div>
        <div class="change-password {{showChangePassword}}">
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <mat-spinner *ngIf="isLoading"></mat-spinner>
            <div class="block">
              <input class="signup-text" type="password" autocomplete="off" placeholder="Old Password" name="password" [(ngModel)]="oldPassword">   
            </div>
            <div class="block">
                <input class="signup-text" type="password" autocomplete="off" placeholder="New Password" name="password" [(ngModel)]="newPassword">
            </div>
            <div class="block">
                <input class="signup-text" type="password" (change)="onChange()" autocomplete="off" placeholder="Confirm Password" name="password" [(ngModel)]="confirmPassword">
            </div>
            <button *ngIf="!isLoading" (click)="changePassword()">Change Password</button>
            <button color="gray" disabled *ngIf="isLoading">Change Password</button>
        </div>
    </section>
</section>